exports.formats = {
  password: /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{6,}$/,
  string: /^[aA-zZ\s]+$/,
  alpha_numeric_spaces: /^[aA-zZ0-9\s]+$/,
  contact_number: /\d{10}/,
  number: /^(\d)\d*(\.\d+)?$/,
}
